// extracted by mini-css-extract-plugin
module.exports = {"flex":"Loading_flex__2sG1Q"};